export default __webpack_public_path__ + "static/media/ovary3.1d2fda29.jpg";